module.exports = __webpack_public_path__ + "static/media/who-it-works-1.a2c74a32.png";